import React from 'react'
import { connect } from 'react-redux'
// import AppBar from '@material-ui/core/AppBar'
// import Toolbar from '@material-ui/core/Toolbar'
import { actionCreators as layoutActionCreators } from 'store/modules/layout'
import { actionCreators as menuActionCreators } from 'store/modules/applicationMenu'
import { withRouter } from 'react-router-dom'
import { localized } from 'decorators'
import { LayoutBase } from '.'
// import { Header } from 'components/header'
import { SideBar } from 'components/sidebar'
import { redirectToLogin, redirectToLogout } from 'utils/redirectTo'
import { getAccessToken, hasAccessToken, isUserInLocalStorage } from 'utils/accessToken'
import { isNull } from 'utils/isNotNull'
import { Overlay } from 'components/overlay'
import { withStyles } from '@material-ui/styles'
import { styles } from './layout.css'
import ToggleButton from './toggleButton'

class Layout extends LayoutBase {
  componentDidMount () {
    if (!this.props.oidc.isLoadingUser) {
      const accessToken = getAccessToken()
      if (isNull(accessToken)) {
        redirectToLogin()
      }
    }
  }
  handleLogout = () => {
    redirectToLogout()
  }
  renderContent () {
    const { layout, oidc } = this.props
    if (layout.redirectToLogin === true) { redirectToLogin() }
    const noUser = (oidc.isLoadingUser === true) || (oidc.user === null)
    const showOverlay = (noUser || !!layout.overlayMessage)

    const doesUserExist = isUserInLocalStorage()
    const message = !showOverlay
      ? null 
      : (noUser ? this.props.localize(doesUserExist ? 'common.userNotSignIn' : 'common.momentPlease') : layout.overlayMessage)

    const { toggleMenu,
      //undergoingActions, markExportAsDownloaded, deleteExport,
      applicationMenu, getMenu, reloadMenu, localize } = this.props
    return (
      <React.Fragment>
        
        {/* <AppBar position='fixed' elevation={0} color='primary'>
          <Toolbar>
            <Header onMenuToggle={toggleMenu}
              showSignInInfo
              oidc={oidc}
              logout={this.handleLogout}
              undergoingActions={undergoingActions}
              applicationMenu={applicationMenu}
              markExportAsDownloaded={markExportAsDownloaded}
              deleteExport={deleteExport}
            />
          </Toolbar>
        </AppBar> */}
        <div id='wrapper' className={layout.toggled ? 'toggled' : ''}>
          <SideBar applicationMenu={applicationMenu} getMenu={getMenu} reloadMenu={reloadMenu} oidc={oidc} />
          <div id='page-content-wrapper'>
            <ToggleButton onMenuToggle={toggleMenu} toggled={layout.toggled} />
            <div className='container-fluid'>
              {hasAccessToken() && this.props.children}
            </div>
          </div>
        </div>
        {showOverlay && <Overlay localize={localize} loading={true} message={message} showLoginLink={doesUserExist} />}
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = {
  toggleMenu: layoutActionCreators.toggleMenu,
  getMenu: menuActionCreators.get,
  reloadMenu: menuActionCreators.reload,
}

export default withStyles(styles)(withRouter(connect(
  ({ layout, oidc, applicationMenu }) => ({ layout, oidc, applicationMenu }),
  mapDispatchToProps
)(localized(Layout))))
